(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      
      // Threshold: header stays fixed until user scrolls past this percentage
      this.stickyThresholdPercent = 10;
      
      // Threshold: logo becomes visible after scrolling past this percentage
      this.logoVisibleThresholdPercent = 5;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Always start with sticky header visible
      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isHidden = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    getScrollPercent() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      return docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollPercent = this.getScrollPercent();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Logo visibility: show logo when scrolled past 5%
      if (scrollPercent > this.logoVisibleThresholdPercent) {
        this.header.classList.add('logo-visible');
      } else {
        this.header.classList.remove('logo-visible');
      }

      // If within first 10% of page OR "always" sticky mode, always show header
      if (scrollPercent <= this.stickyThresholdPercent || this.headerIsAlwaysSticky) {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
        this.header.classList.add('shopify-section-header-sticky');
        if (this.isHidden) {
          this.reveal();
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      // Beyond threshold: use on-scroll-up behavior with premium animations
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling DOWN - hide header
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        if (!this.isHidden) {
          this.hide();
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling UP - show header
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          if (this.isHidden) {
            this.reveal();
          }
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          if (!this.isHidden) {
            this.hide();
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.isHidden = true;
      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.isHidden = false;
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');
    }

    reset() {
      this.isHidden = false;
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get elements
    const container = document.querySelector('.js-scrolling-product-container');
    const productImage = document.querySelector('.js-scrolling-product-image');
    const blocks = document.querySelectorAll('.js-scrolling-block');
    const moleculeColumns = document.querySelectorAll('.molecule-column');
    const redAura = document.querySelector('.section-gradient-aura--red');

    if (!container || !productImage || blocks.length === 0) return;

    // Set custom position if specified
    if (container.dataset.position === 'custom') {
      const customPosition = container.dataset.customPosition || '50%';
      document.documentElement.style.setProperty('--custom-position', customPosition);
    }

    // Get the last block to determine the stopping point
    const lastBlock = blocks[blocks.length - 1];

    // Current position and target position for smooth animation
    let currentY = 0;
    let targetY = 0;
    let lastBlockBottom = 0;
    let containerTop = 0;

    // Linear interpolation function for smooth animation
    function lerp(start, end, factor) {
      return start + (end - start) * factor;
    }

    // Handle fade-in and parallax effects
    function handleScrollEffects() {
      requestAnimationFrame(() => {
        const scrolled = window.pageYOffset;
        const triggerPoint = window.innerHeight * 0.85;

        // Handle scrolling blocks fade-in
        blocks.forEach((block) => {
          const rect = block.getBoundingClientRect();
          if (rect.top <= triggerPoint) {
            block.classList.add('fade-in');
          }
        });

        // Handle molecule columns fade-in and parallax
        moleculeColumns.forEach((column) => {
          const rect = column.getBoundingClientRect();
          if (rect.top <= triggerPoint) {
            column.classList.add('fade-in');

            if (column.classList.contains('molecule-column--left')) {
              column.style.transform = `translateY(${Math.max(0, 100 - scrolled * 0.1)}px)`;
            } else if (column.classList.contains('molecule-column--right')) {
              column.style.transform = `translateY(${Math.min(0, -100 + scrolled * 0.1)}px)`;
            }
          }
        });

        // Handle red aura visibility
        if (redAura) {
          const containerRect = container.getBoundingClientRect();
          const lastBlockRect = lastBlock.getBoundingClientRect();
          const productRect = productImage.getBoundingClientRect();
          
          // Calculate distances
          const productBottom = productRect.bottom;
          const lastBlockBottom = lastBlockRect.bottom;
          const distanceFromBottom = Math.abs(lastBlockBottom - productBottom);
          
          // Calculate progress (starts at 250px away, fully visible at 50px)
          const startDistance = 250;
          const endDistance = 50;
          const progress = Math.max(0, Math.min(1, 
            (startDistance - distanceFromBottom) / (startDistance - endDistance)
          ));

          console.log('Progress:', progress, 'Distance:', distanceFromBottom);

          if (progress > 0) {
            redAura.classList.add('is-visible');
            // Only start pulsing when fully visible
            if (progress === 1) {
              redAura.classList.add('is-pulsing');
            } else {
              redAura.classList.remove('is-pulsing');
            }
            // Apply progress-based scaling
            redAura.style.transform = `translate(-50%, -50%) scale(${progress})`;
            redAura.style.opacity = progress;
            redAura.querySelector('::after').style.transform = 
              `translate(-50%, -50%) scale(${progress})`;
            redAura.querySelector('::after').style.opacity = progress;
          } else {
            redAura.classList.remove('is-visible', 'is-pulsing');
          }
        }
      });
    }

    // Calculate the target product image position based on scroll position
    function calculateTargetPosition() {
      const containerRect = container.getBoundingClientRect();
      const containerTop = containerRect.top;
      const viewportCenter = window.innerHeight / 2;
      const lastBlockRect = lastBlock.getBoundingClientRect();

      // Calculate the target Y position based on scroll
      const scrollProgress = (viewportCenter - containerTop) / containerRect.height;
      let newTargetY = Math.max(0, scrollProgress * containerRect.height - productImage.offsetHeight / 2);

      // Calculate the maximum Y position (bottom of the last block)
      const lastBlockBottom = lastBlockRect.bottom - containerRect.top;
      const maxY = lastBlockBottom - productImage.offsetHeight;

      // Ensure the image doesn't go beyond the last block
      return Math.min(newTargetY, maxY);
    }

    // Update the actual position with smooth animation
    function updatePosition() {
      // Calculate the target position
      targetY = calculateTargetPosition();

      // Smoothly interpolate between current and target position
      currentY = lerp(currentY, targetY, 0.15);

      // Apply the position
      productImage.style.transform = `translateX(-50%)`;
      productImage.style.top = `${currentY}px`;

      // Continue the animation loop
      requestAnimationFrame(updatePosition);
    }

    // Start the animation loop
    updatePosition();

    // Update effects on scroll
    window.addEventListener('scroll', handleScrollEffects, { passive: true });

    // Initial check for elements already in view
    handleScrollEffects();
  });

  } catch(e) { console.error(e); }
})();
})();
